import Button from "react-bootstrap/Button"
import Dropdown from "react-bootstrap/Dropdown"
import Modal from "react-bootstrap/Modal"
import { useEffect, useState } from "react"

import "./prune-old-versions.css"
import { post } from "../../internal/request"
import { API_ADDR } from "../../App"

interface Props {
  hotelReferenceId: string
  show: boolean
  environment: string
  minPrunable: number
  maxPrunable: number
  onHide?: (() => void) | undefined
  onDone?: ((err: string) => void) | undefined
}

export default function PruneOldVersions(props: Props) {

  const [versionsToKeep, setVersionsToKeep] = useState(0);

  useEffect(() => {
    if (props.show) {
      setVersionsToKeep(props.minPrunable > 2 ? props.minPrunable : 2); // Keep 2 versions by default (if possible)
    }
  }, [props.show, props.minPrunable])

  function prune() {
    // Trigger a prune
    post(`${API_ADDR()}/api/prune?hotelreferenceid=${props.hotelReferenceId}&environment=${props.environment}&versionstokeep=${versionsToKeep}`)
      .then(() => {
        // Call done func
        if (props.onDone)
          props.onDone("")
      })
      .catch((err) => {
        // Call done func with error
        if (props.onDone)
          props.onDone(err)
      })
  }

  const ddOptions = []

  for (var i = props.minPrunable; i <= props.maxPrunable; i++) {
    ddOptions.push(<Dropdown.Item key={i} eventKey={i}>{i}</Dropdown.Item>)
  }


  return <Modal
    show={props.show}
    size="lg"
    centered
    backdrop="static"
    keyboard={false}
  >
    <Modal.Header>
      <Modal.Title>
        <div>Prune old versions</div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>Prune old versions from the {props.environment} environment cache, retaining
        <Dropdown as="span" style={{ marginLeft: 5, marginRight: 5 }} onSelect={(eventkey) => setVersionsToKeep(+(eventkey ?? "2"))}>
          <Dropdown.Toggle variant="secondary" id="choose-versions-to-keep">{versionsToKeep}</Dropdown.Toggle>
          <Dropdown.Menu>
            {ddOptions}
          </Dropdown.Menu>
        </Dropdown>
        {versionsToKeep === 1 ? "version" : "versions"}.</div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={props.onHide}>Cancel</Button>
      <Button onClick={() => prune()}>Prune</Button>
    </Modal.Footer>
  </Modal>
}